const dashboard = {
  CreateNewJob: 'Create New Job',
  JobListings: {
    Title: 'Job Listings',
    Filter: {
      Status: 'Status',
    },
  },
};

export default dashboard;
